import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';

import MessagePropType from '../definitions/MessagePropType';
import Question from '../components/Question';


function QuestionPhoneNumber({
    name,
    value,
    fieldOptions,
    labelMessageVariant,
    labelMessage,
    children,
    ...otherProps
}) {
    return (
        <Question
            field={{
                name,
                value: value,
                type: 'phone',
                ...fieldOptions,
            }}
            labelMessage={labelMessage ?? getDefaultMessage(labelMessageVariant)}
            {...otherProps}
        >
            {children}
        </Question>
    );
}

const DEFAULT_MESSAGE_STYLES = [ 'brief', 'conversational' ];

QuestionPhoneNumber.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    fieldOptions: PropTypes.shape({
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        validators: PropTypes.arrayOf(PropTypes.object),
    }),
    labelMessageVariant: PropTypes.oneOf(DEFAULT_MESSAGE_STYLES),
    labelMessage: MessagePropType,
    children: PropTypes.node,
};

QuestionPhoneNumber.defaultProps = {
    name: 'phone',
    value: undefined,
    fieldOptions: undefined,
    labelMessageVariant: 'brief',
    labelMessage: undefined,
    children: undefined,
};


const DEFAULT_MESSAGES = {
    brief: (
        <FormattedMessage
            id="base-ui.phone-number.label.brief"
            defaultMessage="Phone number"
        />
    ),
    conversational: (
        <FormattedMessage
            id="base-ui.phone-number.label.conversational"
            defaultMessage="What is your phone number?"
        />
    ),
};

function getDefaultMessage(messageStyle) {
    if (!DEFAULT_MESSAGES[messageStyle]) {
        throw new RangeError(`QuestionPhoneNumber -- unexpected message style value “${messageStyle}”`);
    }

    return DEFAULT_MESSAGES[messageStyle];
}

export default observer(QuestionPhoneNumber);
